import { reactive } from 'vue';
import { localization } from './l10n';

function get_browser_theme() {
    return matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}

const state = reactive({
    payload: {},
    hash: '',
    theme: localStorage.getItem('data-theme') || get_browser_theme(),
});

function set_theme(value) {
    state.theme = value;
    localStorage.setItem('data-theme', value);
    const body = document.body;
    if (body != null) {
        if (value === 'dark') {
            body.className = 'v-theme--dark';
        } else {
            body.className = 'v-theme--light';
        }
    }
}

export function get_theme() {
    return state.theme;
}

function change_theme() {
    const theme = get_browser_theme();
    if (get_theme() !== theme) {
        set_theme(theme);
    }
}

set_theme(get_theme());

export default class Routes {
    constructor(routes) {
        this.routes = routes;
        window.addEventListener('popstate', () => {
            this.navigate(window.location.search, window.location.hash);
        });
    }

    navigate(search, hash) {
        const items = search.substr(1).split('&');
        const payload = {};
        for (let index = 0; index < items.length; index += 1) {
            const values = items[index].split('=');
            if (values.length === 2) {
                payload[values[0]] = decodeURIComponent(values[1]);
            }
        }
        state.payload = payload;
        if ((hash != null) && (hash !== '')) {
            if (hash[0] === '#') {
                state.hash = decodeURIComponent(hash.substring(1)).trim();
            } else {
                state.hash = decodeURIComponent(hash.trim());
            }
        } else {
            state.hash = '';
        }
    }

    install(app) {
        const $plugin = this;
        const router = {
            push(payload, hash) {
                if (this.href(this.payload, this.hash) !== this.href(payload, hash)) {
                    state.payload = payload;
                    state.hash = hash || '';
                    const href = this.href(payload, hash);
                    window.history.pushState(`/${href}`, undefined, `/${href}`);
                }
            },
            navigate(href) {
                if (this.href(this.payload, this.hash) !== href) {
                    window.history.pushState(`/${href}`, undefined, `/${href}`);
                    $plugin.navigate(href);
                }
            },
            href(payload, hash) {
                const keys = Object.keys(payload);
                let href = '';
                for (let i = 0; i < keys.length; i += 1) {
                    const key = keys[i];
                    if (key != null) {
                        const value = payload[key];
                        if (value != null) {
                            if (href.length > 0) {
                                href += '&';
                            }
                            href += `${key}=${encodeURIComponent(value)}`;
                        }
                    }
                }
                if ((hash != null) && (hash !== '')) {
                    return `?${href}#${hash}`;
                }
                return `?${href}`;
            },
            component() {
                let view = state.payload.view;
                if (view == null) {
                    view = '';
                }
                if (view === '') {
                    const cmp = $plugin.routes[''];
                    return cmp;
                }
                const component = $plugin.routes[view];
                if (component == null) {
                    return undefined;
                }
                return component;
            },
            has_view(view) {
                return $plugin.routes[view] != null;
            },
            match(payload) {
                if (payload == null) {
                    return false;
                }
                let keys = Object.keys(payload);
                const cload = state.payload;
                for (let i = 0; i < keys.length; i += 1) {
                    const key = keys[i];
                    const a = payload[key];
                    if (a != null) {
                        const b = cload[key];
                        if (a !== b) {
                            return false;
                        }
                    }
                }
                keys = Object.keys(cload);
                for (let i = 0; i < keys.length; i += 1) {
                    const key = keys[i];
                    const a = cload[key];
                    if (a != null) {
                        const b = payload[key];
                        if (a !== b) {
                            return false;
                        }
                    }
                }
                return true;
            },
            beforeEach() {
                // not supported
            },
            afterEach() {
                // not supported
            },
        };
        Object.defineProperty(router, 'payload', {
            enumerable: true,
            configurable: false,
            get() {
                return state.payload;
            },
        });
        Object.defineProperty(router, 'hash', {
            enumerable: true,
            configurable: false,
            get() {
                return state.hash;
            },
        });
        Object.defineProperty(router, 'theme', {
            enumerable: false,
            configurable: false,
            get: get_theme,
            set: set_theme,
        });
        const mq = window.matchMedia('(prefers-color-scheme: dark)');
        mq.removeEventListener('change', change_theme);
        mq.addEventListener('change', change_theme);
        app.config.globalProperties.$router = router;
        app.config.globalProperties.$tr = (phrase) => localization.tr(phrase);
        app.config.globalProperties.$plural = (phrase, number) => localization.plural(phrase, number);
        const $mount = app.mount;
        app.mount = (el) => {
            $plugin.navigate(window.location.search, window.location.hash);
            return $mount(el);
        };
    }
}
